import SearchIcon from "@mui/icons-material/Search";
import { Box, InputAdornment, TextField } from "@mui/material";
import React, { useState } from "react";
import { useListContext } from "react-admin";

interface Props {
  children: React.ReactNode;
}

export const SearchableList: React.FC<Props> = ({ children }) => {
  const { filterValues, setFilters, displayedFilters } = useListContext();
  const [searchTerm, setSearchTerm] = useState(filterValues?.q ?? "");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchTerm(value);
    setFilters({ ...filterValues, q: value || undefined }, displayedFilters);
  };

  return (
    <>
      <Box sx={{ px: 2, pt: 1, pb: 1 }}>
        <TextField
          placeholder="Search..."
          value={searchTerm}
          onChange={handleChange}
          size="small"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          sx={{ minWidth: 300 }}
        />
      </Box>
      {children}
    </>
  );
};
